var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('b-icon',{class:_vm.wrapperClass,attrs:{"custom-size":"default","icon":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }